import React from 'react';
import PropTypes from 'prop-types';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';
import shapes from './shapes';

class NotificationBadge extends NamespaceConsumer {
  render() {
    const { showCount, count, tooltip, messages = {}} = this.props;
    const bellClasses = this.classNames(
      this.namespace('btn', 'dropdown-toggle'),
      this.namespace(this.classNames({
        'notifications-mini-bell': showCount && count,
        'notifications-bell': !showCount || !count,
        'no-count': !showCount
      }))
    );

    const messagesLabel = tooltip || messages.headerText;

    if (showCount && count > 0) {
      const badgeClasses = this.namespace('notifications-badge', 'font-primary-bold');

      return (
        <button aria-label={ messagesLabel } className={ bellClasses } title={ tooltip } type='button'>
          <div className={ badgeClasses }>
            { count }
          </div>
        </button>
      );
    }

    return (
      <button aria-label={ messagesLabel } className={ bellClasses } title={ tooltip } type='button' />
    );
  }
}

NotificationBadge.propTypes = {
  ...NamespaceShape,
  tooltip: PropTypes.string,
  messages: shapes.messages
};

export default withNamespace(NotificationBadge);
